import { notification } from "antd";

const ErrorNotificationComponent = ({ errorDetails }) => {

  const notificationCall = () => {
    notification.error({
      message: errorDetails?.message?errorDetails?.message:"Something went wrong",
      placement: "bottomRight",
    });
  };

  return (
    <div>
      {errorDetails?.setErrorOnRender(undefined)}
      {notificationCall()}
    </div>
  );
};

export default ErrorNotificationComponent;
